import { render, staticRenderFns } from "./DictionaryEntries.vue?vue&type=template&id=1fd9773c&scoped=true&"
import script from "./DictionaryEntries.vue?vue&type=script&lang=js&"
export * from "./DictionaryEntries.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryEntries.vue?vue&type=style&index=0&id=1fd9773c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd9773c",
  null
  
)

component.options.__file = "DictionaryEntries.vue"
export default component.exports